import { render } from "./download-document.vue?vue&type=template&id=d276e356&scoped=true&ts=true"
import script from "./download-document.vue?vue&type=script&lang=ts"
export * from "./download-document.vue?vue&type=script&lang=ts"

import "./download-document.vue?vue&type=style&index=0&id=d276e356&lang=scss&scoped=true"

import exportComponent from "E:\\Build\\vsts-agent-win-x64-4.268.0\\_work\\2\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d276e356"]])

export default __exports__